/**
 * @generated SignedSource<<46ca5b28538909d777e6013162eb090f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type progressSummary_issueViewChildIssuesPanel_statusAndResolved$data = {
  readonly isResolved?: boolean | null | undefined;
  readonly statusField?: {
    readonly status: {
      readonly statusCategory: {
        readonly statusCategoryId: string;
      } | null | undefined;
    };
  } | null | undefined;
  readonly " $fragmentType": "progressSummary_issueViewChildIssuesPanel_statusAndResolved";
};
export type progressSummary_issueViewChildIssuesPanel_statusAndResolved$key = {
  readonly " $data"?: progressSummary_issueViewChildIssuesPanel_statusAndResolved$data;
  readonly " $fragmentSpreads": FragmentRefs<"progressSummary_issueViewChildIssuesPanel_statusAndResolved">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "progressSummary_issueViewChildIssuesPanel_statusAndResolved",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isResolved"
        },
        {
          "concreteType": "JiraStatusField",
          "kind": "LinkedField",
          "name": "statusField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraStatus",
              "kind": "LinkedField",
              "name": "status",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraStatusCategory",
                  "kind": "LinkedField",
                  "name": "statusCategory",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "statusCategoryId"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "70506f0e14539fe552d5ea286a59f7fe";

export default node;
